import React from 'react'
import {
  Box,
  Typography,
  TextField,
  IconButton,
  FormControl,
  Stack,
} from '@mui/material'
import { useTranslation } from 'react-i18next'
import ListService from 'api/services/Lists'
import { useForm, Controller, SubmitHandler } from 'react-hook-form'
import { Check, Close } from '@mui/icons-material'
import { useSnackbar } from 'notistack'

interface FormFields {
  notes: string
  oldNotes: string
}

interface Props {
  name: string | null
  notes: string
  propertyAdAlternativeId: string | null
  listId: number | null
  onUpdate: (
    name: string | null,
    notes: string | null,
    propertyAdAlternativeId: string | null
  ) => void
}
function ListingNotes(props: Props) {
  const { name, notes, propertyAdAlternativeId, listId, onUpdate } = props
  const { t } = useTranslation()
  const { enqueueSnackbar } = useSnackbar()
  console.log('props', props)

  React.useEffect(() => {
    reset({
      notes: notes ?? '',
      oldNotes: notes ?? '',
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [notes])

  const updateListMutation = ListService.hooks.useAddToUserFavoritesList({
    onError: () => {
      enqueueSnackbar(t('error.unspecific'), {
        variant: 'error',
      })
    },
    onSuccess: (_data, { notes }) => {
      reset({ notes: notes ?? '', oldNotes: notes ?? '' })
      enqueueSnackbar(t('ListPage.messages.success'), {
        variant: 'success',
      })
      onUpdate(name, notes ?? '', propertyAdAlternativeId)
    },
  })

  const handleClose = () => {
    reset({
      notes: notes ?? '',
      oldNotes: notes ?? '',
    })
  }

  const handleMouseDown = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault()
  }

  const {
    control,
    handleSubmit,
    reset,
    formState: { isDirty },
  } = useForm<FormFields>({
    defaultValues: {
      notes: '',
      oldNotes: '',
    },
  })

  const onSubmit: SubmitHandler<FormFields> = (data) => {
    console.log(data)
    if (data.notes !== data.oldNotes) {
      updateListMutation.mutate({
        listId: listId ?? null,
        propertyAdAlternativeId: propertyAdAlternativeId ?? null,
        name,
        notes: data.notes,
      })
    }
  }

  return (
    <>
      <Controller
        name="notes"
        control={control}
        rules={{
          maxLength: {
            value: 500,
            message: t('ListPage.messages.inputMaxLength'),
          },
        }}
        render={({ field, fieldState: { error } }) => (
          <Box sx={{ display: 'flex', alignItems: 'flex-end', width: '100%' }}>
            <FormControl fullWidth>
              <TextField
                multiline
                rows={4}
                placeholder={t('listDetailView.notes')}
                variant={'outlined'}
                fullWidth
                error={!!error}
                {...field}
                sx={{
                  lineHeight: '15px',
                  '& .MuiInput-root': {
                    fontWeight: 400,
                    fontSize: '14px',
                  },
                  '& .MuiOutlinedInput-root': {
                    fontWeight: 400,
                    fontSize: '14px',
                    padding: '8px',
                  },
                }}
                helperText={
                  error ? (
                    <Typography
                      color="textPrimary"
                      sx={{ fontWeight: 500, fontSize: '14px' }}
                    >
                      {error?.message}
                    </Typography>
                  ) : null
                }
              />
            </FormControl>
            <Stack
              direction="column"
              justifyContent={'flex-start'}
              sx={{ alignSelf: 'flex-start', ml: '2px' }}
            >
              {isDirty ? (
                <IconButton
                  size="small"
                  onClick={() => handleSubmit(onSubmit)()}
                  onMouseDown={handleMouseDown}
                >
                  <Check fontSize="small" sx={{ color: 'success.main' }} />
                </IconButton>
              ) : null}
              {isDirty ? (
                <IconButton
                  size="small"
                  onClick={handleClose}
                  onMouseDown={handleMouseDown}
                  sx={{
                    alignSelf: 'flex-start',
                  }}
                >
                  <Close fontSize="small" color="action" />
                </IconButton>
              ) : null}
            </Stack>
          </Box>
        )}
      />
    </>
  )
}

export default ListingNotes
